'use client';

import { Text } from '@magicschool/spellbook/components/Text';
import { tooltipVariants } from '@magicschool/spellbook/components/Tooltip';
import { cn } from '@magicschool/spellbook/lib/utils';
import type { ReactNode } from 'react';
import type { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import type { TooltipContentProps } from 'recharts/types/component/Tooltip';

export type BarChartTooltipProps = Partial<TooltipContentProps<ValueType, NameType>>;

const DefaultTooltipContent = ({ payload, label }: BarChartTooltipProps) => {
  return (
    <>
      <Text variant="heading-5">{label}</Text>
      <div className="flex gap-2">
        {payload?.map((entry) => (
          <div key={String(entry.dataKey)} className="flex items-center gap-1">
            <Text variant="caption-1">{entry.value}</Text>
          </div>
        ))}
      </div>
    </>
  );
};

export interface BarChartTooltipComponentProps extends BarChartTooltipProps {
  /** Custom render function to override default tooltip content */
  contentOverride?: (props: BarChartTooltipProps) => ReactNode;
}

export const BarChartTooltip = ({ contentOverride, ...props }: BarChartTooltipComponentProps) => {
  const { active, payload } = props;

  if (!active || !payload?.length) {
    return null;
  }

  return (
    <div className={cn(tooltipVariants())} role="status" aria-live="polite">
      {contentOverride ? contentOverride(props) : <DefaultTooltipContent {...props} />}
    </div>
  );
};
